// extracted by mini-css-extract-plugin
module.exports = {"root":"VideosComponent_root__MjRbk","tabsWrapper":"VideosComponent_tabsWrapper__96Hfp","tab":"VideosComponent_tab__uQeWW","active":"VideosComponent_active__H14T1"};